export const userRoot = 'user/v1';
export const vehicleRoot = 'vehicle/v1';
export const priceQuoteRootV1 = 'pricequotes/v1';
export const customerRoot = 'customer/v1';
